<template>
  <component :is="isEditMode() ? 'div' : SharedModal" :controller="controller">
    <div :class="{ 'editmode-info-box': isEditMode() }" class="relative flex flex-col gap-4">
      <slot name="icon" />
      <Heading class="text-center">
        <span v-if="content?.headline">{{ content?.headline }}</span>
        <slot v-else name="headline" />
      </Heading>

      <div
        v-if="content?.richText"
        :class="{ 'max-w-full text-center': textCentered }"
        class="prose"
        v-html="content?.richText"
      />
      <slot v-else class="prose" name="richText" />

      <slot />

      <ContactElement v-if="content?.contact" :contact="content?.contact" />

      <div class="mt-4 flex flex-col gap-4 whitespace-nowrap empty:hidden lg:flex-row">
        <CallToActionComponent
          v-if="containsLink(content?.primary)"
          :link="content?.primary"
          class="w-full"
          @click="$emit('primaryAction')"
        ></CallToActionComponent>
        <slot v-else name="primaryAction"></slot>
        <CallToActionComponent
          v-if="containsLink(content?.secondary)"
          :link="content?.secondary"
          class="w-full"
          @click="$emit('secondaryAction')"
        ></CallToActionComponent>
        <slot v-else name="secondaryAction"></slot>
      </div>
    </div>
  </component>
</template>

<script setup lang="ts">
import { isEditMode } from "~/utils/content/magnolia";
import CallToActionComponent from "~/templates/components/cms/CallToActionComponent.vue";
import { containsLink } from "~/utils/helper/magnolia";
import ContactElement from "~/templates/elements/ContactElement.vue";
import SharedModal from "~/templates/components/shop/shared/SharedModal.vue";
import { Heading } from "~/components/clarity-ui/Heading";

export interface ModalComponentProps {
  controller?: object;
  content?: object;
  textCentered?: boolean;
}

defineProps<ModalComponentProps>();

defineEmits(["primaryAction", "secondaryAction"]);
</script>
